module.exports = __webpack_public_path__ + "static/img/city-mob-gold-ar-2.9c09803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/city-mob-gold-ar-2.png
// module id = 1245
// module chunks = 4